// extracted by mini-css-extract-plugin
module.exports = {"opcoesFiltro":"FiltroOpcoes_opcoesFiltro__ulN8m"};